// extracted by mini-css-extract-plugin
export default {"wrapper":"Information_wrapper__OAn4V","Information":"Information_Information__tE7C4","bio":"Information_bio__W3OwI"};